'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ==========================================================================
// Delivery Info Search Function JS Module
// ==========================================================================


define(['app', 'deliveryInfoAliases'], function (app, deliveryInfoAliases) {
  var DeliveryInfoSearch = function () {
    function DeliveryInfoSearch(classNamePrefix) {
      _classCallCheck(this, DeliveryInfoSearch);

      this.init = this.init.bind(this);
      this.search = this.search.bind(this);
      this.showErrorMessage = this.showErrorMessage.bind(this);

      classNamePrefix = classNamePrefix || 'deliveryInfoSearch_';

      this.classNames = {
        searchInput: classNamePrefix + 'searchInput',
        searchButton: classNamePrefix + 'searchButton',
        selectedTable: classNamePrefix + 'selected',
        selectedAccordion: classNamePrefix + 'selectedAccordion',
        errorMessage: classNamePrefix + 'errorMessage',
        errorMessageShow: classNamePrefix + 'errorMessage-show'
      };
    }

    _createClass(DeliveryInfoSearch, [{
      key: 'init',
      value: function init(element) {
        this.containerElement = element;
        this.errorMessage = element.getElementsByClassName(this.classNames.errorMessage)[0];
        this.searchInput = element.getElementsByClassName(this.classNames.searchInput)[0];
        var searchButton = element.getElementsByClassName(this.classNames.searchButton)[0];

        if (this.searchInput && searchButton) {
          searchButton.addEventListener('click', this.search);
        }
      }
    }, {
      key: 'search',
      value: function search(event) {
        event.preventDefault();

        this.showErrorMessage(false);

        if (this.selectedNamedElements) {
          for (var i = 0; i < this.selectedNamedElements.length; i += 1) {
            var namedElement = this.selectedNamedElements[i];
            if (namedElement.type === 'TABLE') {
              namedElement.element.style.border = 'none';
              app.element.removeClass(this.classNames.selectedTable, namedElement.element);
            } else {
              app.element.removeClass(this.classNames.selectedAccordion, namedElement.element);
            }
          }
          this.selectedNamedElements = undefined;
        }

        this.selectedNamedElements = this.getElementsMatching(this.searchInput.value);

        if (!this.selectedNamedElements.length) {
          this.showErrorMessage(true);
        } else {
          for (var _i = 0; _i < this.selectedNamedElements.length; _i += 1) {
            var _namedElement = this.selectedNamedElements[_i];

            if (_namedElement.type === 'TABLE') {
              app.element.addClass(this.classNames.selectedTable, _namedElement.element);
              _namedElement.element.style.border = '1px solid black';
            } else {
              app.element.addClass(this.classNames.selectedAccordion, _namedElement.element);
            }
          }
          var targetElement = this.selectedNamedElements[0].element;
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }, {
      key: 'getElementsMatching',
      value: function getElementsMatching(searchStr) {
        searchStr = searchStr.toLowerCase();
        if (!searchStr) {
          return Array();
        }

        var tableElements = Array.from(this.containerElement.querySelectorAll('tr')).filter(function (row) {
          return row.querySelector('td');
        });
        var accordionElements = Array.from(this.containerElement.querySelectorAll('div.accordionWidget')).filter(function (row) {
          return row.querySelector('a');
        });
        var namedTableElements = tableElements.map(function (element) {
          return {
            name: element.querySelector('td').innerText.toLowerCase(),
            aliases: deliveryInfoAliases[DeliveryInfoSearch.sanitizeId(element.id)] || [],
            element: element,
            type: 'TABLE'
          };
        });

        var namedAccordionElements = accordionElements.map(function (element) {
          return {
            name: element.querySelector('a').innerText.toLowerCase(),
            aliases: deliveryInfoAliases[DeliveryInfoSearch.sanitizeId(element.querySelector('a').innerText.toLowerCase())] || [],
            element: element,
            type: 'ACCORDION'
          };
        });

        var namedElements = namedTableElements.concat(namedAccordionElements);
        if (searchStr.length == 1) {
          return namedElements.filter(function (namedElement) {
            return namedElement.name.indexOf(searchStr) === 0 || namedElement.aliases.filter(function (alias) {
              return alias.toLowerCase().indexOf(searchStr) === 0;
            }).length > 0;
          });
        }
        return namedElements.filter(function (namedElement) {
          return namedElement.name.indexOf(searchStr) !== -1 || namedElement.aliases.filter(function (alias) {
            return alias.toLowerCase().indexOf(searchStr) !== -1;
          }).length > 0;
        });
      }
    }, {
      key: 'showErrorMessage',
      value: function showErrorMessage(isShow) {
        if (this.errorMessage) {
          if (isShow) {
            app.element.addClass(this.classNames.errorMessageShow, this.errorMessage);
            this.errorMessage.style.display = 'block';
          } else {
            app.element.removeClass(this.classNames.errorMessageShow, this.errorMessage);
            this.errorMessage.style.display = 'none';
          }
        }
      }
    }], [{
      key: 'sanitizeId',
      value: function sanitizeId(id) {
        if (!id) {
          return undefined;
        }
        return id.replace(/\s+/g, '-').toLowerCase();
      }
    }]);

    return DeliveryInfoSearch;
  }();

  return DeliveryInfoSearch;
});
//# sourceMappingURL=delivery-info-search.js.map
